/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationSettings } from '../../models/application-settings';

export interface AppSettingGetApplicationsetting$Params {
  type?: string | null;
  practiceId?: string | null;
}

export function appSettingGetApplicationsetting(http: HttpClient, rootUrl: string, params?: AppSettingGetApplicationsetting$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationSettings>> {
  const rb = new RequestBuilder(rootUrl, appSettingGetApplicationsetting.PATH, 'get');
  if (params) {
    rb.query('type', params.type, {});
    rb.query('practiceId', params.practiceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApplicationSettings>;
    })
  );
}

appSettingGetApplicationsetting.PATH = '/applicationsetting/getapplicationsetting';
